import React from 'react'
import { AlertTriangle } from 'lucide-react'

interface Props {
  children: React.ReactNode
  fallbackMessage?: string
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.error('File preview error:', error)
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.children !== this.props.children && this.state.hasError) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center gap-2 p-12 text-muted-foreground" style={{ minHeight: '200px' }}>
          <AlertTriangle className="h-8 w-8 text-destructive" />
          <p className="text-sm">{this.props.fallbackMessage || 'Failed to load file'}</p>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
